 
import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Add from '@material-ui/icons/Add'
import { graphql } from '@apollo/client/react/hoc'
import * as compose from 'lodash.flowright'
import { CREATE_ISSUE_CATEGORY, GET_ISSUE_CATEGORIES } from '../../../apollo/queries/issue'

class IssueCategoryPopup extends React.Component {
  state = {
    open: false,
    value: "",
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleCreate = () => {
    this.props.create({
        variables: {input: {name: this.state.value}},
        refetchQueries: [{query: GET_ISSUE_CATEGORIES}]
    })
    this.setState({open: false })
  }

  render() {
    return (
      <div>
        <Button size="small" color="primary" onClick={this.handleClickOpen}>
          <Add />
        </Button>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Add Issue Category</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Enter a new Issue Category.
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Category"
              fullWidth
              onChange={e => this.setState({ value: e.target.value })}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleCreate} color="primary">
              Submit
            </Button>
          </DialogActions>
        </Dialog>
        
      </div>
    );
  }
}


export default compose(
    graphql(CREATE_ISSUE_CATEGORY, {name: 'create'})
    )(IssueCategoryPopup) 